"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var ErrorMessage_1 = __importDefault(require("../ErrorMessage"));
//Wraps a question field to display instructions and error message
var FieldWrapper = function (_a) {
    var instructions = _a.instructions, questionNumber = _a.questionNumber, children = _a.children, fieldName = _a.fieldName;
    var parsedInstructions = react_1.useMemo(function () {
        var parsedInstructions = instructions;
        if (parsedInstructions === parsedInstructions.replace(/(<([^>]+)>)/gi, "")) {
            // Instructions does not contain html, surround with <p> tags
            parsedInstructions = "<p>" + instructions + "</p>";
        }
        // If the question number exists, insert it at the beginning of the instructions
        parsedInstructions = questionNumber !== undefined ? parsedInstructions.replace(">", ">" + questionNumber + ". ") : parsedInstructions;
        return parsedInstructions;
    }, [instructions, questionNumber]);
    return (react_1.default.createElement(react_bootstrap_1.Col, null,
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: parsedInstructions } })),
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Col, null, children)),
        react_1.default.createElement(react_bootstrap_1.Row, { className: "justify-content-center p-2" },
            react_1.default.createElement(ErrorMessage_1.default, { fieldName: fieldName }))));
};
exports.default = FieldWrapper;
